'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var GlobalPriceChange = function GlobalPriceChange(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), React__default["default"].createElement("path", {
    d: "M7 15v3h3v2H7v3H5v-3H2v-2h3v-3h2zm6.906-12v1.947c1.847.453 2.776 1.857 2.838 3.386H14.79c-.053-1.11-.637-1.866-2.21-1.866-1.495 0-2.387.675-2.387 1.644 0 .845.645 1.387 2.652 1.911C14.852 10.547 17 11.41 17 13.933c0 1.823-1.37 2.827-3.094 3.156V19h-2.653v-1.929C9.556 16.707 8.106 15.613 8 13.667h1.945c.097 1.049.813 1.866 2.635 1.866 1.953 0 2.387-.977 2.387-1.59 0-.827-.442-1.61-2.653-2.143-2.466-.596-4.155-1.618-4.155-3.671 0-1.716 1.38-2.836 3.094-3.209V3h2.653z"
  }));
};

var GlobalPriceChange$1 = iconStyles()(GlobalPriceChange);

module.exports = GlobalPriceChange$1;
